import React, { useState, useEffect } from "react";
import Moment from "react-moment";
import { useSelector } from "react-redux";

import { SubTab } from "../Cms/TabNInput";
import useRequest from "../../hooks/useRequest";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { API } from "../../constant/api";
import moment from "moment";

const Activated = () => (
  <span className="label label-lg label-light-success label-inline">
    Activated
  </span>
);

const Deactivated = () => (
  <span className="label label-lg label-light-danger label-inline">
    Deactivated
  </span>
);

const ViewOne = (props) => {
  const OrderId = window.location.href.split("/")[4];
  const { id } = props.match.params;

  const [userData, setUserData] = useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);

  const { response: responseUserData, request: requestUserData } = useRequest();
  const { response: responseOfferData, request: requestOfferData } =
    useRequest();

  const { date_format } = useSelector((state) => state.setting);

  useEffect(() => {
    requestOfferData("GET", `order-offer/offer/view/${id}`);

    document.title = "View Order - Easyspare";
  }, []);
  // useEffect(() => {
  //   requestOfferData("GET", `order-offer/orderOffer/${id}`);

  //   document.title = "View Order - Easyspare";
  // }, []);

  useEffect(() => {
    if (responseOfferData) {
      const {
        price,
        notes,
        // year,
        // vin,
        // brandImage,
        // status,
        createdAt,
      } = responseOfferData?.orderOffer;

      setUserDetails([
        { title: "Price", value: price },
        { title: "Notes", value: notes },
        {
          title: "CREATED ON",
          value: <Moment format={date_format}>{createdAt}</Moment>,
        },
      ]);
    }
  }, [responseOfferData]);

  const currentTabIndexHandler = (idx) => {
    setTabIndex(idx);
  };

  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="View Order"
        links={[
          { to: "/", name: "Dashboard" },
          {
            to: `/orders/${responseOfferData?.orderOffer?.orderId}`,
            name: "Back To Orders",
          },
        ]}
      />
      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card card-custom gutter-b">
            <div className="card-header card-header-tabs-line">
              <div className="card-toolbar">
                <ul
                  className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                  role="tablist"
                >
                  {["Order Information"].map((data, index) => (
                    <SubTab
                      key={index}
                      name={data}
                      index={index}
                      onClick={currentTabIndexHandler}
                    />
                  ))}
                </ul>
              </div>
            </div>

            <div
              style={{
                display: tabIndex === 0 ? "block" : "none",
              }}
              className="card-body px-0"
            >
              <div className="tab-content px-10">
                <div
                  className={`tab-pane ${tabIndex === 0 ? "active" : ""}`}
                  id={`kt_apps_contacts_view_tab_1`}
                  role="tabpanel"
                >
                  {userDetails.length > 0 &&
                    userDetails.map((user, index) => (
                      <div key={index} className="form-group row my-2">
                        <label className="col-4 col-form-label">
                          {user.title}
                        </label>
                        <div className="col-8">
                          <span className="form-control-plaintext font-weight-bolder">
                            {user.value}
                          </span>
                        </div>
                      </div>
                    ))}

                  <div className="row"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewOne;
